import { useEffect, useState } from "react";
import { format } from "date-fns";
import { MapPin, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

const toDate = (ymd) => { const [y, m, d] = ymd.split("-").map(Number); return new Date(y, m - 1, d); };

export const useNearbyDays = (customerId, address) => {
  const [state, setState] = useState({ loading: false, data: null });
  useEffect(() => {
    const addr = (address || "").trim();
    if (!customerId && addr.length < 6) { setState({ loading: false, data: null }); return; }
    let live = true;
    setState((s) => ({ ...s, loading: true }));
    const t = setTimeout(() => {
      const q = new URLSearchParams();
      if (customerId) q.set("customer_id", customerId);
      if (addr) q.set("address", addr);
      api.get(`/scheduling/nearby-days?${q}`)
        .then(({ data }) => live && setState({ loading: false, data }))
        .catch(() => live && setState({ loading: false, data: null }));
    }, 400);
    return () => { live = false; clearTimeout(t); };
  }, [customerId, address]);
  return state;
};

export const NearbyDaysHint = ({ customerId, address, onPick, testid = "nearby-days" }) => {
  const { loading, data } = useNearbyDays(customerId, address);
  if (!customerId && !(address || "").trim()) return null;
  return (
    <div className="rounded-lg border border-emerald-200 bg-emerald-50/60 p-3" data-testid={testid}>
      <div className="flex items-center gap-1.5 text-xs font-mono-accent uppercase tracking-widest text-emerald-800 mb-2">
        <MapPin className="w-3.5 h-3.5" /> Already nearby
        {loading && <Loader2 className="w-3 h-3 animate-spin ml-1" />}
      </div>
      {!loading && data && !data.located && <p className="text-xs text-zinc-500" data-testid={`${testid}-not-located`}>No map location for this address yet.</p>}
      {!loading && data?.located && data.recommended_days.length === 0 && (
        <p className="text-xs text-zinc-500" data-testid={`${testid}-empty`}>No booked jobs near here in the next 3 weeks.</p>
      )}
      <div className="flex flex-wrap gap-2">
        {(data?.recommended_days || []).map((d) => (
          <button key={d.date} type="button" onClick={() => onPick?.(d.date)}
            className="text-left rounded-md border border-emerald-300 bg-white px-2.5 py-1.5 hover:border-emerald-500 hover:bg-emerald-50 transition-colors"
            title={`${d.title || "Job"} · ${d.service_address || ""}`} data-testid={`${testid}-day-${d.date}`}>
            <div className="text-xs font-semibold text-zinc-900">{format(toDate(d.date), "EEE MMM d")}</div>
            <div className="text-[10px] text-zinc-500">{d.miles} mi · {d.open_slots} open</div>
          </button>
        ))}
      </div>
    </div>
  );
};
